import React from 'react'

import Card from './Card'

import styles from './styles'

const cardsItems = [
  {
    title: 'CredMap da plataforma Vadu',
    imagePath: '/assets/images/news/vadu_credmap.jpg',
  },
]

export default function () {
  const classes = styles()

  const renderCards = () => {
    return (
      cardsItems.map((card) => (
        <Card
          key={card.title}
          title={card.title}
          imagePath={card.imagePath}
        />
      ))
    )
  }

  return (
    <div className={classes.container}>
      {renderCards()}
    </div>
  )
}
